import { Pipe, PipeTransform } from "@angular/core";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";

@Pipe({
  name: "shiftStyle"
})
export class ShiftStylePipe implements PipeTransform {
  transform(
    value?: NsEmpWebExpData.IShiftData,
    selectedLoginShift?: NsEmpWebExpData.IShiftData,
    selectedLogoutShift?: NsEmpWebExpData.IShiftData,
    nextDayLogoutShift?: NsEmpWebExpData.IShiftData
  ): boolean {
    return (
      selectedLoginShift?.shiftId === value.shiftId || selectedLogoutShift?.shiftId === value.shiftId || nextDayLogoutShift?.shiftId === value.shiftId
    );
  }
}
